import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type Theme = 'white' | 'soft-orange' | 'brand';

interface LayoutContextValue {
  headerTheme: Theme;
}

const LayoutContext = createContext<LayoutContextValue | undefined>(undefined);

export function LayoutProvider({ headerTheme, children }: LayoutContextValue & { children: ReactNode }) {
  return <LayoutContext value={{ headerTheme }}>{children}</LayoutContext>;
}

export function useLayoutContext(): LayoutContextValue {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayoutContext must be used within LayoutProvider');
  }
  return context;
}
